module.exports = __webpack_public_path__ + "img/American.c0296b29.svg";